import React from "react";
import PropTypes from "prop-types";
import Select from "components/shared/Select";

class UserDownloadsSortControl extends React.Component {
  static propTypes = {
    containerSelector: PropTypes.string,
    listItemSelector: PropTypes.string,
    listSelector: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.options = [
      { label: "Recently Downloaded", value: "created-at" },
      { label: "Alphabetical", value: "title" }
    ];
  }

  updateSort(sortBy) {
    const $container = $(this.props.containerSelector);
    const $list = $container.find(this.props.listSelector);
    let $listItems = $list.find(this.props.listItemSelector);

    $listItems.sort(function (a, b) {
      const aVal = $(a).data(sortBy).toString();
      const bVal = $(b).data(sortBy).toString();

      if (aVal > bVal) {
        return 1;
      }
      if (aVal < bVal) {
        return -1;
      }
      return 0;
    });

    // desc vs asc
    if (sortBy === "created-at") {
      $listItems = $($listItems.get().reverse());
    }

    $listItems.detach().appendTo($list);
  }

  onChange(option) {
    this.updateSort(option.value.toLowerCase());
  }

  render() {
    return (
      <Select
        {...this.props}
        baseClassName="lc-select-container--md"
        options={this.options}
        value={this.options[0].value}
        id="sort-control__select"
        placeholder="Filter by first letter"
        onChange={(value) => this.onChange(value)}
      />
    );
  }
}

export default UserDownloadsSortControl;
